module.exports = __webpack_public_path__ + "static/media/creatorstrans.45942a0e.png";